import Banner from "@components/Banner";
import FeaturedItem from "@components/TheHotel65/FeaturedItem";
import BannerFooter from "@components/TheHotel65/BannerFooter";
import Breadcrumbs from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import StayInspired from "@components/Home/StayInspired";
import { usePageContext } from "@providers/PageProvider";
import { useRouteContext } from "@providers/RouteProvider";
import helper, { hotel65Page, meetingPage } from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData, hotel } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const featured = hotel65Page.formatFeatured(pageData);
  const imageFooter: any = meetingPage.formatBannerFooter(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  return (
    <div className="bg-white" data-scroll-container>
      <Header />
      <Banner
        image={_.get(banner, "image")}
        scale={1.1}
        title={_.get(banner, "title", "")}
      />
      <Breadcrumbs data={router.breadcrumbs("theHotel", { hotel })} />
      <FeaturedItem data={featured} />
      <BannerFooter image={imageFooter} />
      <StayInspired mode="light" border="none" />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
          phone: footer.phone,
        }}
      />
    </div>
  );
};

export default View;
